import type { AllRouteEndpoints } from "../routeTypes";
export const engagementInAppMessageColorProfilesUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/in_app_message_color_profiles",
];
